import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import AllocateDatabaseDetails from './AllocateDatabase';
import AllocateTeamToTruck from './AllocateTeamToTruck';
import * as DateHelpers from './DateHelpers';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface AllocateScreen {
    scheduleDate: string;
    scheduleDateFormatted: string;
    scheduleBranchId: number;
    itemTypeGroupFilterId: number;
    tab: string;
    loading: boolean;
}

export class AllocateDatabaseData extends React.Component<RouteComponentProps<{}>, AllocateScreen> {
    constructor(props: any) {
        super(props);

        //set tomorrow as the default schedule date
        var scheduleDate = DateHelpers.addDaysToCurrentDate(1);
        if (DateHelpers.isCurrentDayFriday()) {
            //need to set schedule date to monday
            scheduleDate = DateHelpers.addDaysToCurrentDate(3);
        }

        var scheduleDateFormatted = DateHelpers.formatDate(scheduleDate);

        this.state = {
            scheduleDate: scheduleDate,
            scheduleDateFormatted: scheduleDateFormatted,
            scheduleBranchId: -1,
            itemTypeGroupFilterId: 1,
            tab: "Allocate",
            loading: true
        };

        
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=ViewAllocation&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.setState({ loading: false })
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    updateScheduleDate = (scheduleDate: string) => {
        var scheduleDateFormatted = DateHelpers.formatDate(scheduleDate);

        this.setState({ scheduleDate: scheduleDate, scheduleDateFormatted: scheduleDateFormatted });
    }

    updateItemTypeGroupFilter = (filterId: number) => {
        this.setState({ itemTypeGroupFilterId: filterId });
    }

    goAllocateTruck = (scheduleBranchId: number) => {
        this.setState({ tab: "AllocateTruck", scheduleBranchId: scheduleBranchId });
    }

    goAllocate = () => {
        this.setState({ tab: "Allocate" });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var contents;
        if (this.state.tab == "Allocate") {
            contents = <AllocateDatabaseDetails scheduleDate={this.state.scheduleDate} scheduleDateFormatted={this.state.scheduleDateFormatted} scheduleBranchId={this.state.scheduleBranchId} itemTypeGroupFilterId={this.state.itemTypeGroupFilterId} updateScheduleDate={this.updateScheduleDate} updateItemTypeGroupFilter={this.updateItemTypeGroupFilter} goAllocateTruck={this.goAllocateTruck} />
        }
        else if (this.state.tab == "AllocateTruck") {
            contents = <AllocateTeamToTruck scheduledDate={this.state.scheduleDate} back={this.goAllocate} save={this.goAllocate} />
        }

        return (
            <div>
                <div className="tabsComponent" id="tab-container">
                    <div>
                        {contents}
                    </div>
                </div>

            </div>
        );

    }

};